import { useEffect, useRef } from "react";
import isServer from "@utils/is-server";

export default function useContentLoaderAnimation(loaderShowDuration = 400) {
  const contentRef = useRef(null);
  const loaderRef = useRef(null);

  function hideLoader() {
    loaderRef.current.classList.add("c-loader-overlay--hidden");
  }

  function showContent() {
    contentRef.current.classList.add("c-async-content-fade-in--visible");
  }

  useEffect(() => {
    if (isServer()) return;

    if (contentRef.current) {
      // Synchronizes DOM operations with browser rendering for smoother animations.
      window.requestAnimationFrame(() => {
        setTimeout(() => {
          hideLoader();
          showContent();
        }, loaderShowDuration);
      });
    }
  }, []);

  const loaderProps = {
    className: "c-loader-overlay",
    ref: loaderRef,
  };

  const contentProps = {
    className: "c-async-content-fade-in",
    ref: contentRef,
  };

  return { contentProps, loaderProps };
}
